import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { Activity } from '../dto/activity.dtos';
import { ListVO } from '../dto/list.dto';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DataService {
    private jsonUrl = 'assets/items.json'; // Path to your JSON file
    private data: Activity[] = [];

    constructor(private http: HttpClient) { }

    private load(): Promise<void> {
        return firstValueFrom(this.http.get<Activity[]>(this.jsonUrl)).then(
            (result) => {
                this.data = result;
            }
        );
    }

    async getDataByID(id: number): Promise<Activity> {
        if (this.data.length === 0) {
            await this.load();
        }

        //TODO: Add validations
        return this.data.filter((row) => {
            return row.id === id;
        })[0];
    }

    async searchActivity(searchedQuery: string): Promise<Activity[]> {
        if (!searchedQuery.trim()) {
            return [];
        }

        if (this.data.length === 0) {
            await this.load();
        }

        const query = searchedQuery.trim().toLowerCase();
        const queryWords = query.split(/\s+/);

        return this.data
            .map((activity) => {
                const title = activity.title.toLowerCase();
                const description = activity.description.toLowerCase();

                const fullMatchScore = queryWords.reduce((score, word) => {
                    if (title.includes(word) || description.includes(word)) {
                        return score + 2;
                    }
                    return score;
                }, 0);

                const partialMatchScore =
                    activity.keywords?.reduce((score, keyword) => {
                        if (
                            queryWords.some((word) =>
                                keyword.toLowerCase().includes(word)
                            )
                        ) {
                            return score + 1;
                        }
                        return score;
                    }, 0) || 0;
                const score = fullMatchScore + partialMatchScore;

                return { activity, score };
            })
            .filter(({ score }) => score > 0)
            .sort((a, b) => b.score - a.score)
            .map(({ activity }) => activity);
    }

    getMostReviewed(count: number = 6): Promise<Activity[]> {

        return this.getProductsFromList(92591).then((result) => {
            result.body!.activities.length = count;
            return result.body!.activities;
        });
    }

    getProductsFromList(listId: number): Promise<HttpResponse<ListVO>> {
        return firstValueFrom(
            this.http.get<ListVO>(environment.apiURL + '/api/list/' + listId, {
                observe: 'response',
            })
        );
    }

    getAllProducts(): Promise<HttpResponse<ListVO>> {
        return firstValueFrom(
            this.http.get<ListVO>(environment.apiURL + '/api/products-all', {
                observe: 'response',
            })
        );
    }

    search(
        query: string,
        page: number = 1,
        limit: number = 20
    ): Promise<Activity[]> {
        return firstValueFrom(
            this.http.get<Activity[]>(environment.apiURL + '/api/search', {
                params: {
                    query: query,
                    page: page,
                    size: limit,
                },
            })
        );
    }
    getProductData(activityId: number): Promise<HttpResponse<Activity>> {
        return firstValueFrom(
            this.http.get<Activity>(
                environment.apiURL + '/api/activity/' + activityId,
                {
                    observe: 'response',
                }
            )
        );
    }


    sendFormData(formData: {
        name: string;
        email: string;
        terms: boolean;
        referral?: string;
        phone?: string;
        reason?: string;
        days?: string;
        destinations?: string;

    }): Promise<any> {
        const apiUrl = environment
            ? 'https://signaturetours.com.ar/api/send-email'
            : 'http://localhost:3000/api/send-email';

        return firstValueFrom(this.http.post(apiUrl, formData));
    }
        sendFormDatats(formDatats: {
        name: string;
        email: string;
        terms: boolean;
        referral?: string;
        phone?: string;
        reason?: string;
        days?: string;
        destinations?: string;

    }): Promise<any> {
        const apiUrl = environment
            ? 'https://signaturetours.com.ar/api/send-email-ts'
            : 'http://localhost:3000/api/send-email-ts';

        return firstValueFrom(this.http.post(apiUrl, formDatats));
    }
        sendFormDatact(formDatact: {
        name: string;
        email: string;
        terms: boolean;
        referral?: string;
        phone?: string;
        reason?: string;
        days?: string;
        destinations?: string;

    }): Promise<any> {
        const apiUrl = environment
            ? 'https://signaturetours.com.ar/api/send-email-ct'
            : 'http://localhost:3000/api/send-email-ct';

        return firstValueFrom(this.http.post(apiUrl, formDatact));
    }
        sendFormDataee(formDataee: {
        name: string;
        email: string;
        terms: boolean;
        referral?: string;
        phone?: string;
        reason?: string;
        days?: string;
        destinations?: string;

    }): Promise<any> {
        const apiUrl = environment
            ? 'https://signaturetours.com.ar/api/send-email-ee'
            : 'http://localhost:3000/api/send-email-ee';

        return firstValueFrom(this.http.post(apiUrl, formDataee));
    }

}
